import { getActiveTenant } from './tenantHelpers';

// Assistant chat panel gate. OFF by default; ON for an explicit tenant
// allowlist while the agent surface runs in SHADOW mode (proposes but does not
// execute). Feature flags in uiRegistry are industry-keyed, but this pilot is
// tenant-scoped — widen the allowlist as tenants graduate from shadow, or
// promote to a base/industry flag once it's general.
const AGENT_ASSISTANT_TENANTS = new Set([7]); // t7 = Abon AI (shadow pilot)

export function isAgentAssistantEnabled() {
  const id = Number(getActiveTenant()?.id);
  return Boolean(id) && AGENT_ASSISTANT_TENANTS.has(id);
}

// AI Proposals inbox (agent + watcher proposals). Broader than the chat panel:
// includes t3 (watcher pilot) as well as t7 (shadow chat). Non-pilot tenants
// have AI off, so the surface stays hidden for them — widen as tenants join.
const AI_PROPOSALS_TENANTS = new Set([3, 7]); // t3 watcher pilot, t7 shadow chat

export function isAiProposalsEnabled() {
  const id = Number(getActiveTenant()?.id);
  return Boolean(id) && AI_PROPOSALS_TENANTS.has(id);
}
